import React from 'react';
import { Navigate } from 'react-router-dom';
import { useI18n } from '@/i18n/LanguageContext';
import { useAuth } from '@/contexts/AuthContext';
import Seo from '@/components/Seo';
import SubDashboard from '@/pages/dashboards/SubDashboard';
import OwnerDashboard from '@/pages/dashboards/OwnerDashboard';
import AccountNotices from '@/components/AccountNotices';
import AccountHoldNotice from '@/components/AccountHoldNotice';


const Dashboard: React.FC = () => {
  const { t, path } = useI18n();
  const { profile, loading } = useAuth();

  if (loading) return <div className="py-24 text-center text-slate-500">{t('common.loading')}</div>;
  if (!profile) return <Navigate to={path('/login')} replace />;

  const name =
    profile.company_name || `${profile.first_name || ''} ${profile.last_name || ''}`.trim() || profile.email;

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
      <Seo title={t('nav.dashboard')} description={t('dash.welcome')} noindex />
      <div className="mb-8">
        <p className="text-sm font-semibold text-slate-400">{t('dash.welcome')}</p>
        <h1 className="text-3xl font-extrabold tracking-tight text-slate-900">{name}</h1>
      </div>
      {/* A refund/dispute hold blocks every unlock at the database level, so
          it must be explained above everything else on the dashboard. */}
      <AccountHoldNotice />

      {/* Homeowners / GCs see the mirrored account notices here; the
          subcontractor dashboard renders its own copy under the lead balance. */}
      {profile.user_type !== 'subcontractor' && <AccountNotices />}

      {profile.user_type === 'subcontractor' && <SubDashboard />}
      {profile.user_type === 'homeowner' && <OwnerDashboard mode="project" />}
      {profile.user_type === 'gc' && <OwnerDashboard mode="workorder" />}

    </div>
  );
};

export default Dashboard;
